import { useState } from "react"
import { Alert, Link, Popover, Stack, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { LinkedRateCardBannerItem } from "./linked-rate-card-banner-item"

export function LinkedRateCardsBanner({ linkedRateCards }) {
    const [popoverAnchor, setPopoverAnchor] = useState(null)

    return (
        <Alert severity="info" data-cy="linked-rate-cards-banner">
            <Typography variant="body2">
                This skill map is used by{" "}
                <Link component="button" variant="body2" onClick={openPopover} sx={{ verticalAlign: "baseline" }}>
                    {linkedRateCards.length} rate cards
                </Link>
                . Changes to trades will be reflected there.
            </Typography>
            <Popover
                open={Boolean(popoverAnchor)}
                anchorEl={popoverAnchor}
                onClose={closePopover}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                slotProps={{ paper: { sx: { p: 1, minWidth: 180 } } }}
            >
                <Stack spacing={0}>
                    <Repeat list={linkedRateCards} item={<LinkedRateCardBannerItem />} />
                </Stack>
            </Popover>
        </Alert>
    )

    function openPopover(e) {
        setPopoverAnchor(e.currentTarget)
    }

    function closePopover() {
        setPopoverAnchor(null)
    }
}
